<template>
  <div class="flex justify-around pr-1">
    <div class="max-w-3xl py-5" v-if="canSubmitThisProject">
      <alert
        :message="i18n.safe_live_warning"
        class="mb-5 p-5 text-sm"
        level="info"
      ></alert>

      <alert
        v-if="project.upload_warning"
        :message="project.upload_warning"
        class="mb-5 p-5 text-sm"
        level="warning"
      ></alert>
      <Attempt
        v-for="attempt in uploadAttempts"
        :key="attempt.id"
        :attempt="attempt"
        :project="project"
        class="my-2"
        @upload-route="(e) => (uploadRoute = e)"
      />
      <details
        v-if="uploadRoute"
        class="border-orange-200 bg-orange-100 text-orange-800 rounded border text-sm mb-2"
      >
        <summary class="text-sm cursor-pointer p-5">
          {{ i18n.slow_upload.summary }}
        </summary>
        <p
          class="px-5"
          v-html="
            i18n.slow_upload.details
              .replace(':speedtestUrl', uploadRoute.speedtest)
              .replace(':routeName', uploadRoute.name)
          "
        />
        <div class="flex justify-center pb-5">
          <ranch-button
            action="action-secondary"
            icon=""
            :route="{ name: 'settings', hash: '#transfer-options' }"
          >
            {{ i18n.slow_upload.adjust_options }}
          </ranch-button>
        </div>
      </details>
      <details
        v-if="uploadAttempts.length"
        class="border-blue-200 bg-blue-100 text-blue-800 rounded border text-sm mb-2"
      >
        <summary class="text-sm cursor-pointer p-5">
          {{ i18n.multiple_uploads.summary }}
        </summary>
        <p class="p-5 pt-0" v-html="i18n.multiple_uploads.details" />
      </details>
      <tabs :options="{ useUrlFragment: false }" @changed="tabChanged">
        <tab id="standard" :name="i18n.labels.upload">
          <uploader
            :i18n="this.i18n.tus.drop"
            :project="project"
            class="p-5"
          ></uploader>
        </tab>
        <tab id="reuse" :name="i18n.labels.reuse">
          <bridge
            :i18n="{ ...i18n.reuse, ...$store.state.upload.i18n }"
            :project="project"
            class="p-5"
            v-if="reUse"
          ></bridge>
        </tab>
      </tabs>
    </div>
    <safe-warning
      :label="i18n.not_enough_credits"
      :submitting-project="true"
      v-else
    ></safe-warning>
  </div>
</template>

<script>
import Alert from "../Design/Alert";
import Uploader from "./Upload/Uploader";
import Attempt from "./Upload/Attempt";
import Bridge from "./Upload/Bridge";
import { mapState } from "vuex";

export default {
  props: ["project"],
  components: { Alert, Uploader, Bridge, Attempt },
  data() {
    return {
      reUse: false,
      uploadRoute: null,
    };
  },
  methods: {
    tabChanged(selectedTab) {
      if (selectedTab.tab.id === "reuse" && !this.reUse) {
        this.reUse = true;
      }
    },
  },
  computed: {
    ...mapState({
      canSubmitProject: (state) => state.account.safe.canSubmitProject,
      i18n: (state) => state.dashboard.i18n.new_project.steps.upload,
    }),
    canSubmitThisProject() {
      return this.canSubmitProject || !this.project.priority.price;
    },
    uploadAttempts() {
      return this.$store.getters["tuspload/attempts"](this.project.id);
    },
  },
};
</script>
